import { MultiPurseOverrideState } from "@/admin/types";
import { FetchState } from "@/shared/types";
import _ from "lodash";
import { defineStore } from "pinia";
import * as cardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

export const initialState: MultiPurseOverrideState = {
    multiPurseOverrides: [],
    fetchState: FetchState.Uninitialized
};

export const useMultiPurseOverrideStore = defineStore("multiPurseOverride", {
    state: () => (_.cloneDeep(initialState)),
    actions: {
        loadMultiPurseOverrides () {
            const featureFlagStore = useFeatureFlagStore();
            if (featureFlagStore.flags.bend26527MultiPurseFundOverride === false) {
                return;
            }

            if (this.fetchState !== FetchState.Uninitialized) {
                return;
            }

            this.fetchState = FetchState.Loading;

            cardService.listMultiPurseOverrides()
                .then(response => {
                    this.multiPurseOverrides = response.data.multiPurseOverrides;
                    this.fetchState = FetchState.Loaded;
                })
                .catch(error => {
                    this.fetchState = FetchState.Uninitialized;
                    storeHelper.handleError({ error, rethrow: true });
                });
        }
    }
});